import billingCategoryComponent from "./billing_category.component";
import billingCategoryAll from './all';
import billingCategoryCreate from './create';
import billingCategoryEdit from './edit';

let billingCategoryModule = angular.module('billingCategory', [
    billingCategoryAll,
    billingCategoryCreate,
    billingCategoryEdit
])

    .component('billingCategory', billingCategoryComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';

        $stateProvider.state('billing_category.all', {
            url: '/all/:page',
            component: 'billingCategoryAll'
        })

        $stateProvider.state('billing_category.create', {
            url: '/create',
            component: 'billingCategoryCreate'
        })

        $stateProvider.state('billing_category.edit', {
            url: '/edit/:id',
            component: 'billingCategoryEdit'
        })
    })
    .name;

export default billingCategoryModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/index.js